
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/my-account/my-watches",
      function () {
        return require("private-next-pages/[lang]/my-account/my-watches.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/my-account/my-watches"])
      });
    }
  